import React from "react";
import LocationsSection from "../LocationsSection/LocationsSection";
import DeliverySection from "../DeliverySection/DeliverySection";
import { Box, Divider } from "@mui/material";
import { LocationData } from "./LocationData";
const LocationsContent = () => {
  return (
    <>
      <Box py={{ md: 2, lg: 4 }} id="delivery-locations">
        <h2 className="header-2 font-light">Delivery</h2>
        <LocationsSection
          header="Delivery Zone"
          copy="Our team of Brento Box drivers proudly deliver to over 100 ZIP codes in the Phoenix metro area, including surrounding communities like Scottsdale, Tempe, Gilbert, and more!"
        >
          <DeliverySection />
        </LocationsSection>
      </Box>
      <Divider />
      <Box py={4} id="retail-locations">
        <h2 className="header-2 font-light color-gray-90">Retail</h2>
        <LocationsSection
          header="Vending Machines"
          copy="You can find our meals in our state of the art grab-and-go vending machines, which are open to the public at these locations in the greater Phoenix area."
          subheader="Vending Machine Locations"
          locations={LocationData.vendingMachines}
        />
        <Divider />
        <LocationsSection
          header="Stores"
          copy="We've partnered with several nutrition stores across the valley to provide fresh Brento Box meals that you can purchase."
          subheader="Store Locations"
          locations={LocationData.stores}
        />
        <Divider />
        <LocationsSection
          header="Gyms"
          copy="In addition to our vending machines and partnerships with nutrition stores, we also partner with gyms in the area to provide fresh meals that you can purchase."
          subheader="Gym Locations"
          locations={LocationData.gyms}
        />
      </Box>
    </>
  );
};

export default LocationsContent;
